import React from "react";
import {StyledBoxRow, StyledSpan} from "./StyledComponents";
import {Box, Button, Card, Typography} from "@mui/material";
import {ArrowForwardIosOutlined, CheckOutlined} from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";

function SettingsFragmentContentSelect(props: { options: string[] }) {
  const [option, setOption] = React.useState("none");
  return <Card>
    <Box style={{display: "flex", flexDirection: "column"}}>
      {props.options.map((opt, index) => <Button style={{height: 48}} onClick={() => setOption(props.options[index])}>
        <StyledBoxRow style={{width: "100%"}}>
          <Typography>{opt}</Typography>
          <StyledSpan/>
          {opt === option ? <CheckOutlined style={{width: 24}}/> : null}
        </StyledBoxRow>
      </Button>)}
    </Box>
  </Card>;
}

export abstract class SettingsFragmentContentUtil {

  static renderSeparator() {
    return <StyledSpan style={{marginTop: 16}}/>;
  }

  static renderGroupTitle(text: string) {
    return <Typography variant="body2" style={{fontWeight: "bold", marginTop: 16}}>{text}</Typography>;
  }

  static renderSelect(options: string[]) {
    return <SettingsFragmentContentSelect options={options}/>;
  }

  static renderToggle(text: string, value: boolean, onToggle: (boolean) => void) {
    return <Button style={{height: 48}} onClick={() => onToggle(!value)}>
      <StyledBoxRow style={{alignItems: "center", width: "100%"}}>
        <Typography>{text}</Typography>
        <StyledSpan/>
        <Checkbox size="small" checked={value}/>
      </StyledBoxRow>
    </Button>;
  }

  static renderAction(text: string, onClick: () => void) {
    return <Button style={{height: 48}} onClick={onClick}>
      <StyledBoxRow style={{width: "100%"}}>
        <Typography>{text}</Typography>
        <StyledSpan/>
        <ArrowForwardIosOutlined style={{width: 16}}/>
      </StyledBoxRow>
    </Button>
  }
}
